export default __webpack_public_path__ + "static/banner_2-c533d4c8a030e77b78e9705ce464b005.webp";